import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardBody,
  FormSelect,
  FormGroup,
} from "shards-react";
import Swal from "sweetalert2";
import { Formik } from "formik";
import moment from "moment";

class Agenda extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agendas: [],
    };
  }

  async componentDidMount() {
    // await this.getMeetings();
    // if (this.props.meetingReducer.meetings) {
    //   this.setState({ meetings: this.props.meetingReducer.meetings });
    // }
  }

  async getMeetings() {
    await this.props.getMeetings();

    const { meetings } = this.props.meetingReducer;

    this.setState({
      meetings,
    });
  }

  btnFormatter() {
    return (
      <React.Fragment>
        <a
          type="button"
          className="btn btn-sm btn-success text-white"
          href=""
        >
          ดู/แก้ไข วาระการประชุม
        </a>

        <span style={{ color: "grey" }}> | </span>

        <a
          onClick={() => {
            return Swal.fire({
              text: "Are you sure to delete?",
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes, delete it!",
              cancelButtonText: "No, cancel!",
            }).then((result) => {
              if (result.value) {
                //this.deleteMember(id)
              }
            });
          }}
          type="button"
          className="btn btn-sm btn-danger text-white"
        >
          ลบวาระการประชุม
        </a>
      </React.Fragment>
    );
  }

  renderTable = () => {
    return (
      <table className="table table-bordered">
        <thead>
          <tr>
            <th className="text-center">ชื่อการประชุม</th>
            <th className="text-center">วาระการประชุม</th>
            <th className="text-center">วันที่แก้ไขล่าสุด</th>
            <th className="text-center">แก้ไข/ลบ</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-center align-middle">ทดสอบการประชุม</td>
            <td className="text-center align-middle">วาระที่ 1</td>
            <td className="text-center align-middle">20/07/2020</td>
            <td className="text-center align-middle" >
              {this.btnFormatter()}
            </td>
          </tr>
          <tr>
            <td className="text-center align-middle">ทดสอบการประชุม</td>
            <td className="text-center align-middle">วาระที่ 3</td>
            <td className="text-center align-middle">20/07/2020</td>
            <td className="text-center align-middle" >
              {this.btnFormatter()}
            </td>
          </tr>
          <tr>
            <td className="text-center align-middle">ทดสอบการประชุม</td>
            <td className="text-center align-middle">วาระที่ 3</td>
            <td className="text-center align-middle">20/07/2020</td>
            <td className="text-center align-middle" >
              {this.btnFormatter()}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  render() {
    return (
      <Container fluid>
        <div style={{ padding: 20 }}>
          <Card className="mb-3">
            <CardHeader className="border-bottom">
              <Row>
                <Col sm="6" className="d-flex mb-2 mb-sm-0">
                  <h6 className="mt-1">ระเบียบวาระการประชุม</h6>
                </Col>
                <Col>
                  <Button
                    onClick={() => this.props.history.push(`/meeting/create`)}
                    className=" btn btn-md d-flex ml-auto mr-sm-0 mt-3 mt-sm-0"
                  >
                    เพิ่มวาระการประชุม
                  </Button>
                </Col>
              </Row>
            </CardHeader>
            <CardBody style={{ padding: "1rem" }}>
              <Formik
                initialValues={{
                  start_date: "",
                  end_date: "",
                  category_name: "",
                }}
                onSubmit={async (values) => {
                  const value = {};

                  let startDate = null;
                  let endDate = null;

                  if (values.start_date) {
                    startDate = moment(values.start_date).format("YYYY-MM-DD");
                  }

                  if (values.end_date) {
                    endDate = moment(values.end_date).format("YYYY-MM-DD");
                  }

                  value.start = startDate;
                  value.end = endDate;

                  if (values.category_name) {
                    value.categoryName = values.category_name;
                  }

                  this.props.getReportBookRankPurchase(value);
                }}
              >
                {(props) => {
                  const {
                    values,
                    setFieldValue,
                    handleSubmit,
                    handleChange,
                    isSubmitting,
                  } = props;
                  return (
                    <form onSubmit={handleSubmit}>
                      <Row form>
                        <Col sm="8">
                          <Row>
                            <Col sm="4">
                              <FormGroup>
                                <label>ระบุปี</label>
                                <FormSelect
                                  name="year"
                                  id="year"
                                  placeholder=""
                                  onChange={handleChange}
                                >
                                  <option value="">2020</option>
                                </FormSelect>
                              </FormGroup>
                            </Col>
                            <Col md="8" className="form-group">
                              <label>ชื่อการประชุม</label>
                              <FormSelect
                                name="location"
                                id="location"
                                onChange={handleChange}
                                value={values.location}
                              >
                                <option value="">ทดสอบการประชุม</option>
                              </FormSelect>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </form>
                  );
                }}
              </Formik>
              {this.renderTable()}
            </CardBody>
          </Card>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = ({}) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Agenda);
